export default {
  mapHotelPopover: {
    flex: '1 1 auto',
    fontFamily: data => data.fontFamily1,
    width: '255px',
    boxShadow:'0 0 1px rgba(0, 0, 0, 0.75)',
    background: '#fff',
    color: 'black',
    padding: '10px',
    paddingBottom: '14px',
    zIndex: '1',
    '@supports (filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.75)))':{
      WebkitFilter: 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.75))',
      filter: 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.75))',
      boxShadow: 'none'
    }
  },
  mapTooltip: {
    backgroundColor: '#fff',
    paddingTop: '24px'
  },
  tooltipImage: {
    height: '110px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position:'relative'
  },
  hotelBrandTooltip:{
    position:'absolute',
    fill:'#fff',
    top:'15px',
    right:'15px',
    maxWidth:'67px',
    height:'14px'
  },
  tooltipHotelName: {
    borderBottom: '1px solid #d8d8d8',
    paddingBottom: '6px',
    marginBottom: '5px',
    font: data => 'bold 18px ' + data.fontFamily2
  },
  infoHotelCost: {
    display: 'table',
    width: '100%',
    color: '#333',
    font: data => 'bold 11px ' + data.fontFamily1,
    textAlign: 'left',
    marginBottom: '5px',
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  infoCostFrom: {
    display: 'table-cell',
    verticalAlign: 'middle'
  },
  infoPrice: {
    display: 'table-cell',
    verticalAlign: 'middle',
    fontSize: '18px',
    textAlign: 'right',
    padding: '2px 6px',
    width: '60%',
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  infoCostType: {
    display: 'table-cell',
    verticalAlign: 'middle',
    fontWeight: '400'
  },
  tooltipHotelStars: {
    fontSize: '16px'
  },
  closeButton: {
    fontSize: '9px',
    fontWeight: 'bolder',
    background: 'none',
    display: 'block',
    border: '0',
    margin: '0',
    padding: '0',
    cursor: 'pointer',
    userSelect: 'none',
    float: 'right',
    '&:lang(ar)': {
      float: 'left'
    }
  },
  mapTaxes: {
    font: "300 12px 'Roboto', sans-serif",
    color: '#767676',
    marginTop: '8px',
  },
};
